import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=af31612e&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=af31612e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af31612e",
  null
  
)

export default component.exports